import pug from 'javascripts/core_post_webpack/sitewide_business_elements/research_interest_card/templates/card.jst.pug';
window.JST = window.JST || {};
window.JST[
  'core_post_webpack/sitewide_business_elements/research_interest_card/templates/card'
] = pug;
